/* --------------------------------------------------
                Imports
-------------------------------------------------- */
import { Controller } from "@hotwired/stimulus"

/* --------------------------------------------------
                Stimulus Modal Trigger Controller
-------------------------------------------------- */
// Opens a static Stimulus modal from a trigger rendered outside the modal element.
// The modal itself is a "modal" controller; this only dispatches open to it by id,
// so triggers don't need to host a full modal controller of their own.
// Usage: data-controller="modal-trigger" data-action="click->modal-trigger#open"
//        data-modal-trigger-id-value="pages-invitations-generate"
export default class extends Controller {
  static values = { id: String }

  open(event) {
    if (!this.hasIdValue) return

    const currentTarget = event.currentTarget
    if (!currentTarget || currentTarget.dataset.turbo !== "true") {
      event.preventDefault()
    }

    const modalElement = document.getElementById(`modal-${this.idValue}`)
    if (!modalElement) return

    const controller = this.application.getControllerForElementAndIdentifier(modalElement, "modal")
    if (!controller) return

    // Close an already-open modal we're opening from within (nested open triggers).
    const parentModal = currentTarget.closest('[id^="modal-"]:not(.hidden)')
    if (parentModal && parentModal !== modalElement) {
      this.application.getControllerForElementAndIdentifier(parentModal, "modal")?.close()
    }

    controller.open()
  }
}
